"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addQueryParams = addQueryParams;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addQueryParams(url, params) {
  var queryParams = _queryString["default"].stringify(params);

  return "".concat(url).concat(url.includes('?') ? '&' : '?').concat(queryParams);
}